/**
 * client/src/lib/api/removal-holds.ts — THE query identity for the owner's
 * pending removal holds (round-9 minor 2: the key was hand-typed in two hooks
 * and three invalidation sites; one renamed literal would silently stop
 * cross-surface invalidation, which is the whole point of sharing the key).
 *
 * Live facts, read at request time (owner ruling 2026-09-03): the card
 * derives every line from this response and re-derives on refetch.
 */
import { apiRequest } from "@/lib/queryClient";

export const REMOVAL_HOLDS_QUERY_KEY = ["security/removal-holds"] as const;

export interface RemovalHoldsResponse {
  holds: Array<{
    holdId: string;
    actionKey: string;
    targetRef: string;
    expiresAt: string;
    /** Guardians who could stop THIS hold right now — eligibility-filtered
     *  server-side (conflict set, D-p kill switch, Forensic Pause), never the
     *  raw circle size. Per hold, because a guardian-removal hold conflicts a
     *  guardian a passkey hold does not. See `removal-hold/veto-eligibility.ts`. */
    eligibleGuardianCount?: number;
  }>;
  pauseActive: boolean;
}

export function fetchRemovalHolds(): Promise<RemovalHoldsResponse> {
  return apiRequest<RemovalHoldsResponse>("/api/security/removal-holds");
}
